import {
  uploadNews,
  getPublishList,
  getOrgType,
} from '../../services/articlePublished/microToPublic';
import { getNewsPreview } from '../../services/articleSubmissions/edit';
import { getAppCode } from '../../utils/utils';

const initState = {
  selectedRow: [],
  selectedRowAll: [],
  selectedRowKeys: [],
  spinning: false,
  dataSource: [],
  loading: false,
  totalElements: 0,
  nowOrgType: '',
  params: {
    title: '',
    appCode: getAppCode(),
    page: 1,
    pageSize: 10,
    channelId: '',
    newsTypes: '0,1',
  },
};

export default {
  namespace: 'microToPublic',
  state: initState,
  effects: {
    *fetchUploadNews({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: { spinning: true },
        });
        const response = yield call(uploadNews, params);
        yield put({
          type: 'saveState',
          payload: { spinning: false },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchPublishList({ params }, { call }) {
      try {
        const response = yield call(getPublishList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsPreview({ params }, { call }) {
      try {
        const response = yield call(getNewsPreview, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchGetOrgType({ params }, { call, put }) {
      try {
        const response = yield call(getOrgType, params);
        yield put({
          type: 'saveState',
          payload: {
            nowOrgType: response,
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
